import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import ITSupportAdminPage from "../itsupport/ITSupportAdminPage";
import { Spinner, AccessDenied } from "../itsupport/uiKit";
import API_BASE_URL from "../config";

export default function EmployeeITApprovalPage() {
  const [hasAccess, setHasAccess] = useState(null); // null = checking, true/false = resolved
  const navigate = useNavigate();

  useEffect(() => {
    const employeeId = localStorage.getItem("employeeId");
    const token = localStorage.getItem("token");
    fetch(`${API_BASE_URL}/api/permissions/${employeeId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => setHasAccess(data?.pages?.it_support_approval === true))
      .catch(() => setHasAccess(false));
  }, []);

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <EmployeeNavbar />
      {hasAccess === null ? (
        <Spinner padding="120px 0" />
      ) : hasAccess ? (
        <ITSupportAdminPage />
      ) : (
        <AccessDenied
          message="You don't have permission to access IT Approval. Ask your Admin to grant it if you believe this is a mistake."
          onBack={() => navigate("/emp-it-support")}
        />
      )}
    </div>
  );
}
